<template>
    <div class="relation">
        <div class="kgr-postfix  kgr-postfix--center kgr-postfix--gutters kgr-row relation-row animated fadeIn">
            <div class="kgr-postfix__fixed">
                <kgr-profile-image
                    :src="avatarUrl"
                    :alt="relation.dog.name"
                    size="S"
                />
            </div>

            <div class="kgr-postfix__fluid">
                <a
                    :href="`/backend/clubs/dogs/${relation.dog.id}/show`"
                    class="kgr-link kgr-link--unobtrusive"
                >
                    {{ relation.dog.name }}
                </a>
            </div>
            <div
                v-if="isDeletable"
                class="kgr-postfix__fixed"
            >
                <kgr-button
                    type="red"
                    :value="$t('Zugehörigkeit entfernen')"
                    :pending="pendingRemove"
                    @click="$emit('remove')"
                />
            </div>
        </div>
    </div>
</template>

<script>
import DogMemberRelation from '../../js/dto/DogMemberRelation.js';
import DogRepository from '../../js/repository/DogRepository.js';
import KgrButton from '../common/form/button/KgrButton';
import ProfileImage from '../common/ProfileImage';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-profile-image': ProfileImage,
    },
    props: {
        relation: {
            type: DogMemberRelation,
            required: true,
        },
        pendingRemove: {
            type: Boolean,
            required: true,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        avatarUrl() {
            return this.relation.dog.hasAvatar ? DogRepository.avatarUrl(this.relation.dog.id, this.relation.dog.avatarFileName) : kgr.assetsUrls['clubityAvatarUnknown'];
        }
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .relation:hover {
        background: #f3f3f3;
    }

    .relation-row {
        margin-top: 4px;
        padding-left: 4px;
    }

    .relation-link {
        float: left;
        line-height: 3;
    }

    .buttons {
        float: right;
        margin-top: 8px;
        margin-right: 4px;

        & > a {
            margin-right: 5px;
        }
    }

    .avatar {
        border-width: medium;
        margin-top: 0;
        margin-bottom: 0;
        width: 40px;
        height: 40px;
    }

    .link {
        cursor: pointer;
    }
</style>
